import React from 'react';
import { SpinnerArea } from '../../../../shared/components';
import operEsrrSprTimelineService from '../../../../services/operEsrrSprTimelineService';
import useServiceReducer from '../../../../shared/hooks/useServiceReducer';
import timelineReducer from './timelineReducer';
import EsrrSprTimelineWrapper from './EsrrSprTimelineWrapper';

interface Props {
  operationId: number;
  timelineWidth: number;
}

const EsrrSprTimeline = (props: Props) => {
  const { operationId, timelineWidth } = props;
  const [data, loading, , , ,] = useServiceReducer(
    operEsrrSprTimelineService.getRecords,
    timelineReducer,
    operationId
  );

  return (
    <SpinnerArea loading={loading || timelineWidth === 0}>
      {data && data.records.length > 0 && timelineWidth > 0 && (
        <EsrrSprTimelineWrapper data={data} timelineWidth={timelineWidth} />
      )}
    </SpinnerArea>
  );
};

export default EsrrSprTimeline;
